// downloadJsonFile — minimal browser download helper for Plan B3 Task 2 (the
// template authoring panel's [패키지 내보내기] button).
//
// No shared/exported download utility exists elsewhere in this codebase to
// reuse (surveyed at authoring time): `features/page-editor/lib/export.ts`'s
// `downloadProjectJson`, `features/flow-editor/services/flow-io.ts`'s
// `exportFlow`/`exportAllFlowsAsCogoJson`, `shell/ide-v2/surfaces/
// code-surface.tsx`'s `handleExport`, and `features/data-explorer/services/
// data-io.ts`'s `downloadJson` (module-PRIVATE, not exported) each
// independently re-implement the exact same `Blob -> URL.createObjectURL ->
// <a> -> click -> revokeObjectURL` sequence rather than sharing one. This is
// a minimal, exported version of that same sequence, scoped to the authoring
// feature so `TemplateAuthoringPanel`'s export flow can be unit-tested by
// mocking this single function instead of the DOM download APIs directly.
export function downloadJsonFile(filename: string, text: string): void {
  const blob = new Blob([text], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
